import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {LandingComponent} from './sections/landing/landing.component';
import {NotfoundComponent} from './sections/notfound/notfound.component';

const routes: Routes = [{
  path: 'ifa/:ifaname',
  component: LandingComponent,
  pathMatch: 'prefix'
}, {
  path: '**',
  component: NotfoundComponent
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
